module.exports = __webpack_public_path__ + "static/media/gameWinner.ff0e7367.mp3";